<template>
  <div class="exam-detail container">
    <div class="box">
      <div class="header">
        <el-page-header @back="$router.go(-1)" :content="info.name">
        </el-page-header>
        <!-- <div class="btns">
          <el-button size="small" type="primary" round @click="handleReview"
            >批阅</el-button
          >
          <el-button size="small" type="primary" round>重新编辑</el-button>
        </div> -->
        <el-checkbox v-model="lookAnswer" style="margin-top: 20px"
          >显示答案</el-checkbox
        >
      </div>
      <div class="main-area">
        <!-- 按题型分类 -->
        <div class="questions type-sort">
          <div
            class="one-type"
            v-for="(item, idx) in classify(info.questionList)"
            :key="idx"
          >
            <h3 class="type-title">
              {{ questionIndex(idx + 1) }}. {{ checkType(item.type) }} (共{{
                item.questionList.length
              }}题，{{ sum(item.questionList) }}分)
            </h3>
            <div
              class="one"
              v-for="(q, i) in item.questionList"
              :key="q.questionId"
            >
              <p class="stem">
                <span class="index">{{ i + 1 }}.</span>
                {{ q.question }}
              </p>
              <!-- 多选/单选/判断 -->
              <div
                class="options"
                v-if="
                  q.type == 'RADIO' ||
                  q.type == 'CHECKBOX' ||
                  q.type == 'BOOLEAN'
                "
              >
                <p
                  class="option"
                  v-for="option in q.optionList"
                  :key="option.tag"
                >
                  <span class="tag">{{ option.tag }}.</span>
                  <span class="text">{{ option.option }}</span>
                </p>
              </div>
              <div class="answer" v-show="lookAnswer">
                <b>答案：</b>
                <div
                  v-if="q.type == 'SUPPLY'"
                  style="display: inline-block; vertical-align: top"
                >
                  <p v-for="(answer, i) in q.answerList" :key="i">
                    第{{ i + 1 }}空：{{ answer }}
                  </p>
                </div>
                <span v-else>{{ [...q.answerList].sort().join(",") }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 不按题型分类 -->
        <!-- <div class="questions">
          <div
            class="one"
            v-for="(item, idx) in info.questionList"
            :key="item.questionId"
          >
            <p class="stem">
              <span class="index">{{ idx + 1 }}.</span>
              <span class="type">({{ checkType(item.type) }})</span>
              {{ item.question }}
            </p>
            <div
              class="options"
              v-if="
                item.type == 'RADIO' ||
                item.type == 'CHECKBOX' ||
                item.type == 'BOOLEAN'
              "
            >
              <p
                class="option"
                v-for="option in item.optionList"
                :key="option.tag"
              >
                <span class="tag">{{ option.tag }}.</span>
                <span class="text">{{ option.option }}</span>
              </p>
            </div>
            <div class="answer" v-show="lookAnswer">
              <b>答案：</b>
              <div v-if="item.type == 'SUPPLY'" style="display: inline-block">
                <p v-for="(answer, i) in item.answerList" :key="i">
                  第{{ i + 1 }}空：{{ answer }}
                </p>
              </div>
              <span v-else>{{ [...item.answerList].sort().join(",") }}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
import { examInfo } from "@/api/exam";

export default {
  data() {
    return {
      checkType,
      info: {},
      lookAnswer: true,
    };
  },
  created() {
    this.getInfo(this.$route.query.examId);
  },
  methods: {
    // 获取试卷详情
    getInfo(examId) {
      this.$loading.show();
      examInfo(examId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.info = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 格式化题目
    classify(questions) {
      let list = [];
      if (questions) {
        questions.forEach((e) => {
          let type = e.type;
          let obj = {};
          if (list.length == 0) {
            obj.type = type;
            obj.questionList = [e];
            list.push(obj);
          } else {
            let isHas = false;
            list.forEach((item) => {
              if (item.type == type) {
                item.questionList.push(e);
                isHas = true;
              }
            });
            if (!isHas) {
              let newObj = {};
              newObj.type = type;
              newObj.questionList = [e];
              list.push(newObj);
            }
          }
        });
      }
      return list;
    },
    // 题型序号
    questionIndex(index) {
      if (index == 1) {
        return "一";
      } else if (index == 2) {
        return "二";
      } else if (index == 3) {
        return "三";
      } else if (index == 4) {
        return "四";
      } else if (index == 5) {
        return "五";
      }
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce(function (prev, curr) {
            return curr.score + prev;
          }, 0)
          .toFixed(1)
      );
    },
    handleReview() {
      this.$router.push({
        path: "/classCourse/exam/review",
        query: {
          ...this.$route.query,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exam-detail {
  height: 100%;
  text-align: left;
  .box {
    position: relative;
    padding: 25px 0;
    height: calc(100% - 60px);
    background-color: #fff;
    .header {
      padding: 0 35px;
      ::v-deep .el-page-header {
        .el-page-header__content {
          font-size: 16px;
        }
      }
      .btns {
        position: absolute;
        top: 25px;
        right: 35px;
      }
    }

    .main-area {
      padding: 0 35px;
      height: calc(100% - 40px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }

      .questions {
        &.type-sort {
          .type-title {
            &:first-child {
              margin-top: 20px;
            }
          }
        }
        .one {
          margin: 20px 0;
          .stem {
            color: #303133;
            .type {
              margin: 0 5px;
              color: #909399;
            }
          }
          .options {
            .option {
              margin-top: 15px;
              color: #303133;
              .tag {
                margin-right: 5px;
              }
            }
          }
          .answer {
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>